module.exports = __webpack_public_path__ + "static/WEDDING E&M-236-a3f75f46db6f8209830a7a4336ad630c.jpg";